import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import Fab from '@material-ui/core/Fab';
import Mic from '@material-ui/icons/Mic';
import MicOff from '@material-ui/icons/MicOff';
import Tooltip from '@material-ui/core/Tooltip';

import clsx from 'clsx';

import useLocalAudioToggle from '../../../hooks/useLocalAudioToggle/useLocalAudioToggle';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    fab: {
      margin: theme.spacing(1),
    },
  })
);

export default function ToggleAudioButton(props: { disabled?: boolean }) {
  const classes = useStyles();
  const [isAudioEnabled, toggleAudioEnabled] = useLocalAudioToggle();
  const needsAttentionClass = isAudioEnabled ? 'normal' : 'needs-attention';

  return (
    <Tooltip
      title={isAudioEnabled ? 'Turn off audio' : 'Turn on audio'}
      placement="top"
      PopperProps={{ disablePortal: true }}
      className={clsx('audio-button', needsAttentionClass)}
    >
      <Fab className={classes.fab} onClick={toggleAudioEnabled} disabled={props.disabled}>
        {isAudioEnabled ? <Mic /> : <MicOff />}
      </Fab>
    </Tooltip>
  );
}
